'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FieldList = function (_React$Component) {
	_inherits(FieldList, _React$Component);

	function FieldList(props) {
		_classCallCheck(this, FieldList);

		var _this = _possibleConstructorReturn(this, (FieldList.__proto__ || Object.getPrototypeOf(FieldList)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(FieldList, [{
		key: 'getConstraintsText',
		value: function getConstraintsText(item) {
			var maximum = item.maximum,
			    exclusiveMaximum = item.exclusiveMaximum,
			    minimum = item.minimum,
			    exclusiveMinimum = item.exclusiveMinimum,
			    maxLength = item.maxLength,
			    minLength = item.minLength;

			var result = [];
			// Integer values
			if (maximum !== undefined && minimum !== undefined) {
				// between
				var betweenMinAndMax = {
					min: _react2.default.createElement(
						'b',
						null,
						exclusiveMinimum ? minimum + 1 : minimum
					),
					max: _react2.default.createElement(
						'b',
						null,
						exclusiveMaximum ? maximum - 1 : maximum
					)
				};
				result.push(this.intl.formatHTMLMsg('between {min} and {max}', betweenMinAndMax));
			} else if (maximum === undefined && minimum !== undefined) {
				// at least
				var atLeast = {
					min: _react2.default.createElement(
						'b',
						null,
						exclusiveMinimum ? minimum + 1 : minimum
					)
				};
				result.push(this.intl.formatHTMLMsg('at least {min}', atLeast));
			} else if (maximum !== undefined && minimum === undefined) {
				// at most
				var atMost = {
					max: _react2.default.createElement(
						'b',
						null,
						exclusiveMaximum ? maximum - 1 : maximum
					)
				};
				result.push(this.intl.formatHTMLMsg('at most {max}', atMost));
			}

			// String / array values
			if (maxLength !== undefined && minLength !== undefined) {
				// between
				var betweenMinAndMaxLength = {
					min: _react2.default.createElement(
						'b',
						null,
						minLength
					),
					max: _react2.default.createElement(
						'b',
						null,
						maxLength
					)
				};
				result.push(this.intl.formatHTMLMsg('length between {min} and {max}', betweenMinAndMaxLength));
			} else if (maxLength === undefined && minLength !== undefined) {
				// at least
				var atLeastLength = {
					min: _react2.default.createElement(
						'b',
						null,
						minLength
					)
				};
				result.push(this.intl.formatHTMLMsg('length at least {min}', atLeastLength));
			} else if (maxLength !== undefined && minLength === undefined) {
				// at most
				var atMostLength = {
					max: _react2.default.createElement(
						'b',
						null,
						maxLength
					)
				};
				result.push(this.intl.formatHTMLMsg('length at most {max}', atMostLength));
			}

			return result;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    editable = _props.editable,
			    deletable = _props.deletable,
			    selectable = _props.selectable,
			    fieldDetailRender = _props.fieldDetailRender,
			    headers = _props.headers,
			    striped = _props.striped,
			    noteColumnName = _props.noteColumnName,
			    emptyMessage = _props.emptyMessage,
			    className = _props.className;


			var columns = [{
				key: 'name',
				className: function className(item) {
					var classes = ['field-name', 'break-word'];
					if (item) {
						// item can be null if it is applying className to the column
						if (item.validationState !== 'success') {
							classes.push('ux-text-color-' + item.validationState);
							classes.push('ux-background-color-' + item.validationState);
						}
					}
					return classes.join(' ');
				},
				name: this.intl.formatMsg('Field'),
				format: function format(item) {
					var readOnlyRequired = void 0,
					    defaultValue = void 0;

					if (item.readOnly && !item.required) {
						readOnlyRequired = _react2.default.createElement(
							'span',
							{ className: 'field-readonly' },
							_this2.intl.formatHTMLMsg('read-only'),
							'\xA0'
						);
					} else if (!item.readOnly && item.required) {
						readOnlyRequired = _react2.default.createElement(
							'span',
							{ className: 'field-required' },
							_this2.intl.formatHTMLMsg('required'),
							'\xA0'
						);
					} else if (item.readOnly && item.required) {
						readOnlyRequired = _react2.default.createElement(
							'span',
							{ className: 'field-readonly field-required' },
							_this2.intl.formatHTMLMsg('read-only, required'),
							'\xA0'
						);
					}
					if (item.default) {
						var defaultVal = {
							default: _react2.default.createElement(
								'b',
								null,
								item.default
							)
						};
						defaultValue = _this2.intl.formatHTMLMsg(', default is {default}', defaultVal);
					}
					var errorAction = void 0;
					if (item.validationState !== 'success' && item.errorMessage) {
						errorAction = _react2.default.createElement(_.ItemAction, {
							key: 'item-edit-error',
							item: item,
							onAction: item.onEdit,
							className: 'ux-text-color-' + item.validationState,
							tooltip: item.errorMessage,
							icon: 'warning'
						});
					}
					var maxAndMinValues = _this2.getConstraintsText(item);

					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'span',
							{ className: 'field-name' },
							item.name,
							errorAction
						),
						_react2.default.createElement(
							'span',
							{ className: 'field-detail' },
							readOnlyRequired && readOnlyRequired,
							_react2.default.createElement(
								'span',
								{ className: 'field-type' },
								item.type
							),
							maxAndMinValues.length > 0 && ' ',
							maxAndMinValues.length > 0 && maxAndMinValues,
							_react2.default.createElement(
								'span',
								{ className: 'field-default' },
								defaultValue
							)
						)
					);
				}
			}, {
				key: 'description',
				className: function className(item) {
					var classes = ['field-description', 'break-word'];
					if (item) {
						// item can be null if it is applying className to the column
						if (item.validationState !== 'success') {
							classes.push('ux-background-color-' + item.validationState);
						}
					}
					return classes.join(' ');
				},
				name: this.intl.formatMsg('Description'),
				format: function format(item) {
					var enumValue = void 0;
					if (item.enum) {
						var enumVal = {
							enum: _react2.default.createElement(
								'b',
								null,
								item.enum.join(', ')
							)
						};
						enumValue = _this2.intl.formatHTMLMsg('Available values: {enum}', enumVal);
					}

					return _react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'span',
							{ className: 'field-description' },
							item.description
						),
						_react2.default.createElement(
							'span',
							{ className: 'field-detail' },
							_react2.default.createElement(
								'span',
								{ className: 'field-enum' },
								enumValue
							)
						)
					);
				}
			}];

			if (noteColumnName) {
				// Add a Source model column
				columns.push({
					key: 'model',
					className: function className(item) {
						var classes = ['field-notes'];
						if (item) {
							// item can be null if it is applying className to the column
							if (item.validationState === 'error') {
								classes.push('ux-background-color-error');
							}
						}
						return classes.join(' ');
					},
					name: noteColumnName,
					format: function format(item) {
						return item.note || '';
					}
				});
			}

			if (editable || deletable) {
				// Add a actions column
				columns.push({
					key: '_actions_',
					className: function className(item) {
						var classes = ['actions'];
						if (item) {
							// item can be null if it is applying className to the column
							if (item.validationState !== 'success') {
								classes.push('ux-background-color-' + item.validationState);
							}
						}
						return classes.join(' ');
					},
					name: '',
					format: function format(item) {
						var actions = [];
						if (editable) {
							if (item.onEdit) {
								actions.push(_react2.default.createElement(_.ItemAction, {
									key: 'item-edit',
									item: item,
									onAction: item.onEdit,
									className: 'edit',
									icon: 'pencil'
								}));
							}
						}
						if (deletable) {
							if (item.onDelete) {
								actions.push(_react2.default.createElement(_.ItemAction, {
									key: 'item-delete',
									item: item,
									onAction: item.onDelete,
									className: 'trash',
									icon: 'trash2'
								}));
							}
						}
						return _react2.default.createElement(
							'div',
							null,
							actions
						);
					}
				});
			}

			var items = [];
			if (this.props.children) {
				items = _react2.default.Children.map(this.props.children, function (child) {
					return _extends({}, child.props, {
						// additional/overwritten
						required: child.props.required || false, // unrendered: does not set default
						readOnly: child.props.readOnly || false // unrendered: does not set default
					});
				});
			}

			if (!items.length && emptyMessage) {
				return _react2.default.createElement(_.ContentMessage, {
					title: this.intl.formatMsg('No model fields'),
					detail: emptyMessage,
					imgClass: 'gg icon-GG-empty-list',
					className: (0, _classnames2.default)('sm', 'empty', className),
					inlineContent: true
				});
			}

			return _react2.default.createElement(_.DataTable, {
				className: (0, _classnames2.default)('field-list', className),
				multiSelectable: selectable,
				expandedRows: true,
				expandedRowRender: fieldDetailRender,
				striped: striped,
				headers: headers,
				columns: columns,
				items: items,
				onChangeSelection: this.props.onSelection,
				preSelectedRows: this.props.selectedRows
			});
		}
	}]);

	return FieldList;
}(_react2.default.Component);

FieldList.propTypes = {
	/**
  * Callback for selection changes to Table
  */
	onSelection: _propTypes2.default.func,
	/**
  * array in indexes to preselect
  */
	selectedRows: _propTypes2.default.array,

	/**
  * Class name to apply to component.
  */
	className: _propTypes2.default.string,

	/**
  * Adds an edit icon.  Use `onEdit` with your `FieldList.Field`.
  */
	editable: _propTypes2.default.bool,

	/**
  * Adds an delete icon.  Use `onDelete` with your `FieldList.Field`.
  */
	deletable: _propTypes2.default.bool,

	/**
  * Adds a checkbox.
  */
	selectable: _propTypes2.default.bool,

	/**
  * Shows headers (default: true).
  */
	headers: _propTypes2.default.bool,

	/**
  * Shows striped table (default: true).
  */
	striped: _propTypes2.default.bool,

	/**
  * Shows a note column with this name.
  */
	noteColumnName: _propTypes2.default.string,

	/**
  * Message to render when empty.  If not set, will render empty table.
  */
	emptyMessage: _propTypes2.default.string,

	/**
  * Renderer for extra data that a field may have. return null for no extra data.
  */
	fieldDetailRender: _propTypes2.default.func
};

FieldList.defaultProps = {
	editable: false,
	deletable: false,
	selectable: false,
	headers: true,
	striped: false,
	className: ''
};

/**
 * Child Field component.
 */

var Field = function (_React$Component2) {
	_inherits(Field, _React$Component2);

	function Field() {
		_classCallCheck(this, Field);

		return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
	}

	_createClass(Field, [{
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return Field;
}(_react2.default.Component);

Field.propTypes = {
	/**
  * Name of the field.
  */
	name: _propTypes2.default.string,

	/**
  * Type
  */
	type: _propTypes2.default.string,

	/**
  * Description
  */
	description: _propTypes2.default.string,

	/**
  * The default value
  */
	default: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number]),

	/**
  * If the field is expandable with extra details
  */
	hasDetails: _propTypes2.default.bool,

	/**
  * An optional node.  Use with `noteColumnHeader`.
  */
	note: _propTypes2.default.node,

	/**
  * Indicates the field is read-only (visual only).
  */
	readOnly: _propTypes2.default.bool,

	/**
  * Indicates the field is required.
  */
	required: _propTypes2.default.bool,

	/**
  * A callback when `selectable` is true.
  */
	onSelect: _propTypes2.default.func,

	/**
  * A callback when 'editable' is true.
  */
	onEdit: _propTypes2.default.func,

	/**
  * A callback when 'deletable' is true.
  */
	onDelete: _propTypes2.default.func,

	/**
  * Field validation state.
  */
	validationState: _propTypes2.default.oneOf(['success', 'info', 'warning', 'error']),

	errorMessage: _propTypes2.default.string,

	/**
  * Additional field information
  */
	context: _propTypes2.default.object,

	/**
  * Minimal value allowed for the parameter
  */
	minimum: _propTypes2.default.number,

	/**
  * If the minimum value is excluded
  */
	exclusiveMinimum: _propTypes2.default.bool,

	/**
  * Maximum value allowed for the parameter
  */
	maximum: _propTypes2.default.number,

	/**
  * If the maximum value is excluded
  */
	exclusiveMaximum: _propTypes2.default.bool,

	/**
  * Max length allowed for strings / arrays
  */
	maxLength: _propTypes2.default.number,

	/**
  * Min length allowed for strings / arrays
  */
	minLength: _propTypes2.default.number
};

Field.defaultProps = {
	readOnly: false,
	required: false,
	validationState: 'success',
	maximum: undefined,
	exclusiveMaximum: false,
	minimum: undefined,
	exclusiveMinimum: false,
	maxLength: undefined,
	minLength: undefined
};

// FieldList.Field = Field;

var FieldListIntl = (0, _reactIntl.injectIntl)(FieldList);

FieldListIntl.Field = Field;

var _default = FieldListIntl;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(FieldList, 'FieldList', 'src/components/FieldList.jsx');

	__REACT_HOT_LOADER__.register(Field, 'Field', 'src/components/FieldList.jsx');

	__REACT_HOT_LOADER__.register(FieldListIntl, 'FieldListIntl', 'src/components/FieldList.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/FieldList.jsx');
}();

;